import React from 'react'

function TechSelectionConical() {
  return (
    <embed src="\pdfs\E1.5.6_VA-K_Conical_displacement_outlet_07.2014-1_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionConical